export enum PickupStatus {
  CANCELED = 'CANCELED',
  DROPOFF = 'DROPOFF',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  PICKUP_COMPLETED = 'PICKUP_COMPLETED',
  PICKUP_FAILED = 'PICKUP_FAILED',
  PICKUP_SCHEDULED = 'PICKUP_SCHEDULED',
}
